var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"top":"","right":"","color":_vm.color,"timeout":_vm.timeout,"app":_vm.app,"multi-line":_vm.multiline,"transition":"slide-x-reverse-transition"},model:{value:(_vm.appear),callback:function ($$v) {_vm.appear=$$v},expression:"appear"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }